var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pajamas:twitter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.7025 14.3804L30.0211 2.29883H27.5754L18.6182 12.7886L11.4606 2.29883H3.20654L14.0286 18.163L3.20654 30.8314H5.6522L15.1128 19.7526L22.6719 30.8314H30.926L19.7025 14.3804ZM16.354 18.3015L15.2575 16.7221L6.53263 4.15345H10.2887L17.3281 14.2968L18.4246 15.8763L27.5775 29.0624H23.8214L16.354 18.3015Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.21696f16b08a91001b3768dccee303d9.svg";
export { ForwardRef as ReactComponent };